<template>
  <div class="view-simulators">
    <div class="tool-title">
      <button class="btn btn-sm py-0" @click="goSimulator(null)" v-if="current">
        <i class="icon-arrow-left text-white"></i>
      </button>
      Simuladores
    </div>
    <div class="row" v-if="!current">
      <div
        v-for="simulator in simulators"
        :key="simulator.id"
        class="col-lg-4 col-md-6 col-sm-6 py-4"
      >
        <div class="card">
          <div class="position-relative">
            <img class="card-img-top" :src="simulator.icon_image" />
            <div class="card-body">
              <h4>{{ simulator.name }}</h4>
              {{ simulator.subtitle }}
            </div>
          </div>
          <div class="card-footer">
            <button
              class="btn btn-primary btn-block"
              @click="goSimulator(simulator.slug)"
            >
              Realizar simulado
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-4" v-if="current">
      <SimulatorsChat :code="code"></SimulatorsChat>
    </div>
  </div>
</template>

<script>
import SimulatorsChat from "./SimulatorsChat.vue";
import { mapState } from "vuex";

export default {
  components: { SimulatorsChat },
  computed: {
    ...mapState("tools", ["aiTools"]),
    simulators() {
      return this.aiTools.filter(tool => tool.is_simulator);
    },
    current() {
      const subslug = this.$route.params.subslug;
      return subslug && this.aiTools.find(tool => tool.slug === subslug);
    },
    code() {
      return this.current?.iframe_code;
    }
  },
  methods: {
    goSimulator(slug) {
      this.$router.push({ params: { subslug: slug || null } });
    }
  }
};
</script>

<style lang="scss">
.view-simulators {
  .row > div {
    display: flex;
  }

  .card {
    background-color: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(2px);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    width: 100%;
    height: 100%;
    border: none;
    overflow: hidden;
    position: relative;

    .card-body {
      position: absolute;
      bottom: 0;
      left: 0;
      background-image: linear-gradient(to bottom, transparent, #000c);
      width: 100%;
      padding-bottom: 16px;
      padding-top: 32px;
      text-shadow: 0 1px 10px #000c;
    }

    .card-img-top {
      aspect-ratio: 8 / 5;
      object-fit: cover;
      opacity: 0.8;
    }

    .card-footer {
      border: none;
      background-color: none;
      padding-top: 16px;

      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        position: unset;
      }
    }
  }
}
</style>
